<template>
  <span v-if="value">
    <icon name="check" />
    {{$t('yes')}}
  </span>
  <span v-else>
    <icon name="close" />
    {{$t('no')}}
  </span>
</template>

<script>
export default {
  name: 'yes',
  props: {
    value: Boolean,
  },
  i18n: {
    messages: {
      de: {
        yes: 'ja',
        no: 'nein',
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// Yes.vue?f27b051c